import { XyoNetworkWrapper } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

export const NetworkSettingsContext = createContext<Map<number, XyoNetworkWrapper>>(new Map<number, XyoNetworkWrapper>())
